export default function setQueryFilters(filters, url) {
  for (const filter in filters) {
    if (filters[filter] !== null && filters[filter] !== undefined && filters[filter] !== "") {
      url.addParameter(filter, filters[filter]);
    }
  }
}
